import { getLocalPath } from '../../utility'

const getLinkCompoundByType = (type) => {
  switch (type) {
    case 'hippo:mirror':
      return hippoMirrorLink
    case 'cti:StringCompound':
      return stringCompoundLink
    default:
      console.log(`${type} not found in getLinkPayload`)
      return undefined
  }
}
const ctiLinkCompound = (link) => {
  if (link._meta.type !== 'cti:LinkCompound') {
    console.log('argument not type of cti:LinkCompound')
    return
  }
  const innerLink = link.Link[0]
  const type = innerLink._meta.type

  return {
    text: link.text,
    icon: link.icon,
    target: link.target,
    description: link.description,
    type,
    url: getLinkCompoundByType(type)(innerLink),
  }
}

/**
 * returns string
 */
const hippoMirrorLink = (link) => {
  if (link._meta.type !== 'hippo:mirror') {
    console.log(`link._meta.type ${link._meta.type} !== hippo:mirror`)
    return
  }
  return `${getLocalPath()}/binaries/${link._meta.mirror.path}`
}

/**
 * returns string
 */

const stringCompoundLink = (link) => {
  if (link._meta.type !== 'cti:StringCompound') {
    console.log('link type !== cti:StringCompound')
    return
  }
  return link.string
}

const mailToLink = (title, href) => {
  return `mailto:?subject=${title}&body=${title}'%0D%0A%0D%0A'${window.location.origin}${href}`
}

export { ctiLinkCompound, mailToLink }
